import { render, staticRenderFns } from "./HomeWidgetInfoItem.vue?vue&type=template&id=bf5fc528&scoped=true&"
import script from "./HomeWidgetInfoItem.vue?vue&type=script&lang=js&"
export * from "./HomeWidgetInfoItem.vue?vue&type=script&lang=js&"
import style0 from "./HomeWidgetInfoItem.vue?vue&type=style&index=0&id=bf5fc528&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf5fc528",
  null
  
)

export default component.exports